import { Controller } from '@hotwired/stimulus'
import Inputmask from 'inputmask'

export default class extends Controller {
  static targets = ['input']

  inputTargetConnected(input) {
    const inputMask = new Inputmask('ssn', {
      autoUnmask: true,
      removeMaskOnSubmit: true
    })

    inputMask.mask(input)
  }
}
